export interface OptionType {
  label: string;
}

const commonSearchTermsList: OptionType[] = [{ label: "riskbedömningar" }, { label: "kommunikation" }, { label: "systematiskt arbetsmiljöarbete" }];

export { commonSearchTermsList };
